import React from 'react';
import {
    RadioButton,
    Banner,
    Stack,
    Button,
    Popover,
    ActionList
} from '@shopify/polaris';
import CustomerConditionComponent from './CustomerConditionComponent';
import { AvailableCustomerFilters, AvailableProductFilters, AvailableOrderFilters } from '../../common/UICustomerFilter';
import { apiFetch as fetch } from '../../common/Helpers';

class ResourceConditionsPaneComponent extends React.Component {

    nextProductFilterId = 0;

    constructor(props) {
        super(props)

        this.state = {
            filters: this.props.filters,
            filtersLogicalOperator: this.props.filtersLogicalOperator,
            expanded: this.props.expanded,
            active: false,
            distinctValues: {}
        }

        this.nextProductFilterId = this.getLargestId(this.state.filters);
    }

    getLargestId = (items) => {
        if (items.length === 0) {
            return 0;
        }

        const max = items.reduce(function (max, item) {
            return Math.max(max, item.id);
        }, 0);
        return max + 1;
    }

    toggleActive = () => {
        this.setState({ "active": !this.state.active });
    }

    render() {

        let hasConditions = this.state.filters.length > 0;
        const expanded = this.state.expanded;
        let availableFilter = AvailableProductFilters;

        if (this.props.resourceType === "Customer") {
            availableFilter = AvailableCustomerFilters;
        }

        if (this.props.resourceType === "Order") {
            availableFilter = AvailableOrderFilters;
        }

        let activator = <Button onClick={this.toggleActive} disclosure>Add Condition</Button>;
        let sections = this.generateSections(availableFilter);
        let main = (<div>
            {hasConditions &&
                <div>
                    <div className="logicalConditionContainer">
                        <p><span>{this.props.resourcePlural} must match: </span>
                            <RadioButton
                                id="andLogicalConditionRadio"
                                label="all conditions"
                                checked={this.state.filtersLogicalOperator === 'And'}
                                onChange={this.handleConditionChange}
                            />
                            <RadioButton
                                id="anyLogicalConditionRadio"
                                label="any condition"
                                checked={this.state.filtersLogicalOperator === 'Or'}
                                onChange={this.handleConditionChange}
                            />
                        </p>
                        <br></br>
                    </div>
                    <Stack distribution="fill" spacing="extraLoose">
                        <CustomerConditionComponent
                            tags={this.props.tags}
                            filters={this.state.filters}
                            onFilterConditionValueChange={this.handleFilterConditionValueChange}
                            onFilterConditionOperatorChange={this.handleFilterConditionOperatorChange}
                            onFilterRequirementChange={this.handleFilterRequirementChange}
                            distinctValues={this.state.distinctValues}
                            onFilterDelete={this.handleFilterDelete} />
                    </Stack>
                </div>
            }
            {/* <Link url="">Let us know what you think</Link> */}
            {!hasConditions &&
                <Banner>
                    <p>No conditions have been defined. All store {this.props.resourcePlural} will be considered for this operaiton.</p>
                </Banner>
            }
            <br />
            <div >
                <Popover
                    active={this.state.active} activator={activator}
                    preferredAlignment="left" preferredPosition="mostSpace"
                    onClose={this.toggleActive}>
                    <ActionList sections={sections} onActionAnyItem={this.onActionSelected} />
                </Popover>
            </div></div>);

        if (!expanded) {
            main = (<br />);
        }

        return main;
    }

    onActionSelected = () => {
        this.setState({ "active": false });
    }

    onCreateFilter = (filterDescriptor) => {

        var newFilter = filterDescriptor.createFilter(this.nextProductFilterId++);
        let newConditions = [...this.state.filters,
            newFilter
        ];

        this.setState({
            filters: newConditions,
            active: false,
        }, () => this.onFiltersUpdatedInternal());

        if (newFilter.body.filterType === "AttributeFilter") {
            const encodedAttribute = encodeURIComponent(newFilter.body.attributePath);
            fetch(`api/customers/attributes/distinct/${encodedAttribute}`, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(data => {

                    var current = this.state.distinctValues;
                    current[newFilter.body.attributePath] = data;
                    this.setState({
                        distinctValues: current
                    });
                });
        }
    }

    generateSections = (filterDescriptors) => {

        let sections = [];

        filterDescriptors.forEach(_ => {

            let currentSection = sections[_.category];

            if (currentSection == null) {
                currentSection = {
                    title: _.category,
                    items: []
                };
                sections[_.category] = currentSection;
            }

            currentSection.items.push({
                content: _.title,
                helpText: _.description,
                onAction: () => { this.onCreateFilter(_) }
            })

        });

        return Object.keys(sections).map(key => sections[key]);
    }

    containsSpecialCharacters(str) {
        var regex = /[=[\]'\\,<>?]/g;
        return regex.test(str);
    }

    onApplyClick = () => {
        this.props.onFiltersUpdated(this.state.filters, this.state.filtersLogicalOperator);
    }

    onToggleExpanded = () => {

        this.setState({
            expanded: !this.state.expanded
        });
    }

    getFilterById = (id) => {
        var matching = this.state.filters.filter((item) => item.id === id);

        if (matching.length > 0) {
            return matching[0];
        }

        return null;
    }

    handleFilterConditionOperatorChange = (id, newValue) => {

        let filter = this.getFilterById(id);

        if (filter == null) {
            return;
        }

        // TODO: Consider changing this to immutable
        filter.updateConditionOperator(newValue);

        this.setState({
            filters: this.state.filters
        }, () => this.onFiltersUpdatedInternal());
    }

    handleFilterRequirementChange = (id, newValue) => {
        let filter = this.getFilterById(id);

        if (filter == null) {
            return;
        }

        // TODO: Consider changing this to immutable
        filter.updateRequirement(newValue);

        this.setState({
            filters: this.state.filters
        }, () => this.onFiltersUpdatedInternal());
    }

    handleFilterConditionValueChange = (id, newValue) => {

        let filter = this.getFilterById(id);

        if (filter == null) {
            return;
        }

        // TODO: Consider changing this to immutable
        filter.updateConditionValue(newValue);

        this.setState({
            filters: this.state.filters
        }, () => this.onFiltersUpdatedInternal());
    }

    handleConditionChange = (newvalue, id) => {

        if (id === "andLogicalConditionRadio") {
            this.setState({ filtersLogicalOperator: "And" }, () => this.onFiltersUpdatedInternal());
        }
        else {
            this.setState({ filtersLogicalOperator: "Or" }, () => this.onFiltersUpdatedInternal());
        }
    }

    onFiltersUpdatedInternal = () => {
        if (!this.props.autoUpdateFilters) {
            return;
        }

        this.props.onFiltersUpdated(this.state.filters, this.state.filtersLogicalOperator);
    }

    handleFilterDelete = (index) => {
        var newFilters = [
            ...this.state.filters.slice(0, index),
            ...this.state.filters.slice(index + 1)
        ];

        this.setState({
            filters: newFilters
        }, () => this.onFiltersUpdatedInternal());
    }

    componentDidMount() {
    }
}

ResourceConditionsPaneComponent.defaultProps = {
    onFiltersUpdated: () => { },
    filtersLogicalOperator: "And",
    filters: [],
    autoUpdateFilters: false,
    updateButtonText: "Apply",
    tags: [],
    expanded: true,
    resourceType: "Customer",
    resourceSingular: "product",
    resourcePlural: "products",
    title: 'PRODUCT CONDITIONS',
}

export default ResourceConditionsPaneComponent;